import { z } from "zod"
import { TranslationKey } from "../../i18n/translation-key"
import { CustomerClub } from "../../store"
import { DamperBookingInfo } from "../damper-service"
import { CustomBookingSectionItemSnapshot } from "../reception"
import { ServiceWashWithoutBookability } from "../service-wash"
import { PackageInBooking } from "./maintenance-booking"

export interface CommonDataRequiredForBooking {
  customerClub: CustomerClub | null
  serviceStepHeaderText: string
  serviceStepDescriptionText: string
  availableServicesDescriptionText: string
}

export const RescheduleBookingSchema = z.object({
  newDate: z.date({
    message: "common.validation.handInDateRequired" satisfies TranslationKey,
  }),
})

export type RescheduleBooking = z.infer<typeof RescheduleBookingSchema>

export const CancelBookingSchema = z.object({
  // Also cancel the other bikes booked together with this one
  cancelWholeBooking: z.boolean(),
})

export type CancelBooking = z.infer<typeof CancelBookingSchema>

export interface BookingCancellationOptions {
  // Other still-booked bikes in the same booking as this job
  otherBookedJobsInBookingCount: number
}

export const CommonBookingSchema = z.object({
  storeId: z.string().uuid(),
  description: z.string().nullable(),
  handInDate: z.coerce.date(),
  bookedThroughJulo: z.boolean(),
  agreedToJoinStoreClub: z.boolean(),
  agreedToContactInfoBeingStored: z.boolean(),
})

export enum BookingType {
  MAINTENANCE = "MAINTENANCE",
  EVENT = "EVENT",
}

enum EmergencyServiceType {
  FLAT_TIRE = "FLAT_TIRE",
  CHAIN_BREAK = "CHAIN_BREAK",
  WIRE_BREAK = "WIRE_BREAK",
}

export interface FeeInBooking {
  id: string
  name: string
  price: number
  description: string | null
}

export interface ServiceBooking {
  emergencyServiceType: EmergencyServiceType | null
  type: BookingType
  description: string | null
  selectedPackages: PackageInBooking[]
  selectedWash: ServiceWashWithoutBookability | null
  selectedCustomItems: CustomBookingSectionItemSnapshot[]
  selectedFees: FeeInBooking[]
  customerInfoCanBeStored: boolean
  customerWantsToJoinStoreClub: boolean
  createdAt: Date
  images: { id: string; url: string }[]
  damperBookingInfos: DamperBookingInfo[]
}
